import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfEquipmentMps
export const getBillOfEquipmentMps = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment-mp`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfEquipmentMp
export const getBillOfEquipmentMpById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfEquipmentMp
export const createBillOfEquipmentMp = async (billOfEquipmentMpData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-equipment-mp`, billOfEquipmentMpData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfEquipmentMp
export const updateBillOfEquipmentMp = async (id, billOfEquipmentMpData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-equipment-mp/${id}`, billOfEquipmentMpData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfEquipmentMp
export const deleteBillOfEquipmentMp = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-equipment-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// GET billOfEquipmentMps by maintenancePlanId
export const getBillOfEquipmentMpsByMaintenancePlanId = async (maintenancePlanId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment-mp`, {      params: { maintenancePlanId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching billOfEquipmentMps by MP:', error.response?.data || error);
    throw error;
  }
};
